import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { hasCompletedOnboarding } = useAuthStore();

  if (!hasCompletedOnboarding) {
    return navigateTo('/customer/personal-details');
  }
});
